import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import FeedbackLayer from "../components/FeedbackLayer";

const FeedbackPage = () => {
    return (
        <MasterLayout>
            <FeedbackLayer />
        </MasterLayout>
    );
};

export default FeedbackPage;